import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/computer-device-network-wifi-connection.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M140 204a12 12 0 1 1-12-12 12 12 0 0 1 12 12m97.08-117a172 172 0 0 0-218.16 0 8 8 0 0 0 10.16 12.37 156 156 0 0 1 197.84 0A8 8 0 0 0 237.08 87M205 122.77a124 124 0 0 0-153.94 0A8 8 0 0 0 61 135.31a108 108 0 0 1 134.06 0 8 8 0 0 0 11.24-1.3 8 8 0 0 0-1.3-11.24m-32.26 35.76a76.05 76.05 0 0 0-89.42 0 8 8 0 0 0 9.42 12.94 60 60 0 0 1 70.58 0 8 8 0 1 0 9.42-12.94" }, null, -1)])]);
}
var computer_device_network_wifi_connection_default = { render };
//#endregion
export { computer_device_network_wifi_connection_default as default, render };

//# sourceMappingURL=computer-device-network-wifi-connection.svg.js.map